import { Pipe, PipeTransform } from '@angular/core';
import { ApprovalType } from '../../enums/approval/approval.enum'; 

@Pipe({
  name: 'approvalType'
})
export class ApprovalTypePipe implements PipeTransform {

  transform(value: ApprovalType): string {
    switch (value) {
      case ApprovalType.EstimateApproval:
        return 'Estimate Approval';
      case ApprovalType.SalesOrderApproval:
        return 'Sales Order Approval';
      case ApprovalType.InvoiceApproval:
        return 'Invoice Approval';
      case ApprovalType.None:
      default:
        return 'None';
    }
  }
}
